import * as React from "react";

import { createHocDisplayName, GetProps, nullElement } from "./TypingUtils";

export interface VisibilityRequiredProps {
    visible?: boolean;
}

export function withVisibilityProps<C extends React.ComponentType<GetProps<C>>>(
    WrappedComponent: C
): React.ComponentType<JSX.LibraryManagedAttributes<C, GetProps<C>> & VisibilityRequiredProps> {
    function WithVisibilityPropWrapper(
        props: JSX.LibraryManagedAttributes<C, GetProps<C>> & VisibilityRequiredProps
    ): JSX.Element | null {
        const { visible, ...restProps } = props;
        if (visible != undefined && !visible) {
            return nullElement;
        }
        // @ts-ignore Баг с HOC-ами https://github.com/Microsoft/TypeScript/issues/28938
        return <WrappedComponent {...restProps} />;
    }

    WithVisibilityPropWrapper.displayName = createHocDisplayName(WrappedComponent, "VisibilityProp");
    return WithVisibilityPropWrapper;
}
